import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';
import { CandleData } from 'client/voladeum/candles/types';
import { selectCandles } from 'ducks/candles/selectors';
import { selectPair } from 'ducks/pair/selectors';
import { useVisibleTimeseries } from 'hooks/useVisibleTimeseries';
import { usePairApi } from 'pages/hooks/usePairApi';
import { useAppSelector } from 'store/hooks';

import { NavigatorGraph } from 'components/chart/navigator/NavigatorGraph';
import { CandleValidationsModal } from 'components/modals/candle-validations/CandleValidationsModal';
import { CandleWorkersModal } from 'components/modals/candle-workers/CandleWorkersModal';
import { Page } from 'components/page/Page';

import { CANDLE_WINDOW } from '../../../constants';

import { CandleHeatmap } from './candle-heatmap/CandleHeatmap';
import { CandleOHLCV } from './candle-ohlcv/CandleOHLCV';
import { CandleWorkersHeatmap } from './candle-workers-heatmap/CandleWorkersHeatmap';
import { PairInformation } from './pair-information/PairInformation';

export default () => {
  const { search } = useLocation();
  const voladeum_pair = useAppSelector(selectPair);
  const voladeum_candles = useAppSelector(selectCandles);
  const { getData } = usePairApi();

  useEffect(() => {
    getData();
  }, [getData, search]);

  const candles = useMemo<CandleData[]>(
    () =>
      voladeum_candles.map((c) => ({
        x: c.u,
        o: c.c[0] || 0,
        h: c.c[1] || 0,
        l: c.c[2] || 0,
        c: c.c[3] || 0,
        v: c.c[4] || 0,
      })),
    [voladeum_candles]
  );

  const { visible, setVisible } = useVisibleTimeseries(candles, CANDLE_WINDOW);

  return (
    <Page title={voladeum_pair.pair_name}>
      <PairInformation />
      <CandleOHLCV candles={candles} visible={visible} />
      <NavigatorGraph candles={candles} visible={visible} setVisible={setVisible} />
      <CandleWorkersHeatmap />
      <CandleHeatmap candles={candles} />
      <CandleWorkersModal />
      <CandleValidationsModal />
    </Page>
  );
};
